import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faTimesCircle,
  faPhone,
  faBirthdayCake,
  faChevronLeft,
  faUser,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faArrowDown,
  faArrowUp,
  faClock
} from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { convertUtcToIst } from "../../utilities.js";
import * as urls from "../../api/urlHelper";
import * as func from "../../api/apiHelper";

const ViewMSSubscriptions = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { matchseekerId } = location.state;

  const [subscription, setSubscription] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [globalFilters, setGlobalFilters] = useState({
    transactionType: "",
    startDate: "",
    endDate: "",
  });

  const limit = 5;

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      setLoading(true);
      try {
        const subscriptionResponse = await func.get(
          `${
            urls.GET_MATCHSEEKER_SUB_DETAILS + matchseekerId
          }?page=${currentPage}&limit=${limit}`,
          globalFilters
        );
        if (subscriptionResponse.status === 200) {
          setSubscription(subscriptionResponse?.data?.subscription);
          setPaymentHistory(subscriptionResponse?.data?.paymentHistory);
          setTotalPages(subscriptionResponse?.data?.totalPages);
        } else {
          toast.warn(subscriptionResponse);
          navigate("/user-management/match-seekers/list");
        }
      } catch (error) {
        toast.error("Error fetching subscription details");
      }
      setLoading(false);
    };

    fetchSubscriptionDetails();
  }, [matchseekerId, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };





  return (
    <div className="max-w-7xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
      <div className="flex items-center mb-6">
        <button
          onClick={() => window.history.back()}
          className="flex items-center text-gray-600 hover:text-gray-800"
        >
          <FontAwesomeIcon icon={faChevronLeft} className="mr-2" />{" "}
          <h4 className="text-xl font-semibold text-gray-900">
            Subscription Details
          </h4>
        </button>
      </div>

      {/* Current Subscription Details */}
      {subscription && (
        <div className="p-6 bg-blue-50 rounded-lg shadow-md mb-6">
          <h2 className="text-lg font-semibold text-blue-900 mb-4">
            Current Subscription
          </h2>
          <div className="grid grid-cols-2 gap-6 text-gray-700 text-sm">
            {/* Left Column */}
            <div className="space-y-1">
              <p>
                <strong>Price:</strong> ₹{subscription?.price}
              </p>
              <p>
                <strong>Status:</strong>
                {subscription?.status === "ACTIVE"||subscription.status ? (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    className="text-green-500 ml-2"
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    className="text-red-500 ml-2"
                  />
                )}
              </p>
              <p>
                <strong>Start Date:</strong>{" "}
                {subscription?.serviceStartDate
                  ? convertUtcToIst(subscription?.serviceStartDate)
                  : "N/A"}
              </p>
              <p>
                <strong>End Date:</strong>{" "}
                {subscription?.serviceEndDate
                  ? convertUtcToIst(subscription?.serviceEndDate)
                  : "N/A"}
              </p>
            </div>

            {/* Right Column */}
            <div className="space-y-1">
              <p>
                <strong>Duration:</strong> {subscription?.duration} Days
              </p>
              <p>
                <strong>GST ({subscription?.gstPercentage}%):</strong> ₹
                {subscription?.gstAmount || "N/A"}
              </p>
              <p>
                <strong>Discount:</strong> ₹{subscription?.discount}
              </p>
              <p className="text-md font-semibold">
                <strong>Total:</strong> ₹{subscription?.total}
              </p>
            </div>
          </div>

        </div>
      )}

      {/* Payment History */}
      <div className="bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-lg font-semibold text-gray-800 mb-4">
          Payment History
        </h2>
        {loading ? (
          <div className="flex justify-center items-center space-x-2">
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce"></div>
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
            <div className="w-3 h-3 bg-blue-500 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          </div>
        ) : paymentHistory.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-gray-700 bg-white border border-gray-200 rounded-lg">
              <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                <tr className="text-left">
                  <th className="px-4 py-3 text-left">Payment Id</th>
                  <th className="px-4 py-3 text-left">Date</th>
                  <th className="px-4 py-3 text-left">Amount</th>
                  <th className="px-4 py-3 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((payment) => (
                  <tr key={payment._id} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-3">
                      {payment?.merchant_transaction_id}
                    </td>
                    <td className="px-4 py-3">
                     

                        {  payment?.payment_transaction_confirmation_time?convertUtcToIst(
                        payment?.payment_transaction_confirmation_time
                      ):"N/A"}
                    </td>
                    <td className="px-4 py-3 font-bold">₹ {payment?.amount}</td>
                    <td className="px-4 py-3">
                      {payment?.payment_status === "SUCCESS" ? (
                        <span className="text-green-600 flex items-center">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="mr-1"
                          />{" "}
                          Paid
                        </span>
                      ) : payment?.payment_status === "FAILED" ? (
                        <span className="text-red-600 flex items-center">
                          <FontAwesomeIcon
                            icon={faTimesCircle}
                            className="mr-1"
                          />{" "}
                          Failed
                        </span>
                      ) : payment?.payment_status === "INITIATED" ? (
                        <span className="text-yellow-500 flex items-center">
                          <FontAwesomeIcon
                            icon={faClock}
                          
                            className="mr-1"
                          />{" "}
                          Pending
                        </span>
                      ) : (
                        <span className="text-blue-600 flex items-center">
                          <FontAwesomeIcon icon={faArrowUp} className="mr-1" />{" "}
                          Refunded
                        </span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <p className="text-center text-gray-500">No transactions found.</p>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="mt-4 flex justify-center items-center space-x-2">
            <button
              className={`px-3 py-1 rounded-md ${
                currentPage === 1
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-[#19224B] hover:bg-[#19224B] hover:text-white"
              }`}
              onClick={() => handlePageChange(1)}
              disabled={currentPage === 1}
            >
              First
            </button>

            <button
              className={`px-3 py-1 rounded-md ${
                currentPage === 1
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-[#19224B] hover:bg-[#19224B] hover:text-white"
              }`}
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>

            <span className="text-sm font-medium px-3">
              Page {currentPage} of {totalPages}
            </span>

            <button
              className={`px-3 py-1 rounded-md ${
                currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-[#19224B] hover:bg-[#19224B] hover:text-white"
              }`}
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>

            <button
              className={`px-3 py-1 rounded-md ${
                currentPage === totalPages
                  ? "text-gray-400 cursor-not-allowed"
                  : "text-[#19224B] hover:bg-[#19224B] hover:text-white"
              }`}
              onClick={() => handlePageChange(totalPages)}
              disabled={currentPage === totalPages}
            >
              Last
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewMSSubscriptions;
